/**
 * Created by user on 2018/2/17/017.
 */

export * from '@lazy-cjk/novel-filename';
import m from '@lazy-cjk/novel-filename';

export default m;
